import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "message__info__assignee",
  "use": "message__info__assignee-usage",
  "viewBox": "0 0 16 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 15\" id=\"message__info__assignee\">\n  <path d=\"M12.345 8.65c1.155.033 2.271 2.997 2.413 4.158.08.651-.543 1.192-1.206 1.192H2.214c-.663 0-1.294-.542-1.206-1.192.158-1.159 1.519-4.124 2.533-4.158 1.165-.04 2.751.76 4.341.762 1.634.001 3.272-.796 4.464-.762zM7.882 1a3.059 3.059 0 1 1 0 6.118 3.059 3.059 0 0 1 0-6.118z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol